import React from "react";
import "./aboutme.scss";
import Leftbar from "../components/leftbar";
import { Link } from "react-router-dom";
import { ISkill, SkillData } from "../data";
import EachSkill from "../components/eachskill";
import { motion } from "framer-motion";

const AboutMe: React.FC = () => {
  return (
    <div className="portfolio">
      <Leftbar />
      <motion.div
        className="content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="head"
          initial={{ x: -20 }}
          animate={{ x: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <h1>About Me</h1>
          <div className="menu">
            <Link to={"/"} style={{ color: "wheat" }}>About me</Link>
            <Link to={"/portfolio"}>Portfolio</Link>
          </div>
        </motion.div>
        <motion.div
          className="line"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <span className="border"></span>
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          
        </motion.p>
        <motion.div
          className="doing"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <motion.h1
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            What I am doing?
          </motion.h1>
          <motion.div
            className="skills"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.5 }}
          >
            {
              SkillData.map((item: ISkill, index: number) => (
                <EachSkill index={index} logo_path={item.logo_path} title={item.title} text={item.text} key={index} />
              ))
            }
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default AboutMe;
